import AddTrainingSession from "../../components/addTraining";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";

const AddTraining = () => {
  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Styled.ColumnDiv>
        <AddTrainingSession />
      </Styled.ColumnDiv>
    </Styled.MainDiv>
  );
};

export default AddTraining;
